import { App } from './app/App.ts';
import './style.css';

const mount = document.getElementById('app');
if (!mount) throw new Error('#app not found');

const app = new App(mount);
void app.start();

// Handy in the browser console for poking at a running session.
(window as unknown as { flappyHHI: App }).flappyHHI = app;
